import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "approval-container" }
const _hoisted_2 = {
  key: 0,
  class: "pending-summary"
}
const _hoisted_3 = {
  key: 1,
  class: "loading-state"
}
const _hoisted_4 = {
  key: 2,
  class: "approvals-list"
}
const _hoisted_5 = ["data-push-id"]
const _hoisted_6 = { class: "card-header-row" }
const _hoisted_7 = { class: "employee-info" }
const _hoisted_8 = { class: "avatar-badge" }
const _hoisted_9 = { class: "employee-name" }
const _hoisted_10 = { class: "employee-sub" }
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "dates-bento" }
const _hoisted_13 = { class: "date-col" }
const _hoisted_14 = { class: "date-val" }
const _hoisted_15 = { class: "duration-arrow" }
const _hoisted_16 = { class: "date-col" }
const _hoisted_17 = { class: "date-val" }
const _hoisted_18 = { class: "location-box" }
const _hoisted_19 = { class: "reason-box" }
const _hoisted_20 = { class: "reason-text" }
const _hoisted_21 = { class: "card-actions" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 3,
  class: "empty-state"
}
const _hoisted_25 = { class: "empty-icon-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "custom-toolbar" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button, { color: "light" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, { class: "custom-title" }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("Attendance Approvals", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _ctx.fetchPendingApprovals,
                    color: "light",
                    class: "refresh-btn"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.refreshOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "approval-content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!_ctx.loading && _ctx.pendingList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.notificationsOutline,
                    class: "summary-icon"
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", null, [
                    _cache[1] || (_cache[1] = _createTextVNode("You have ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.pendingList.length), 1),
                    _cache[2] || (_cache[2] = _createTextVNode(" pending request(s) requiring your review.", -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_ion_spinner, {
                    name: "crescent",
                    color: "primary"
                  }),
                  _cache[3] || (_cache[3] = _createElementVNode("span", null, "Fetching pending requests...", -1))
                ]))
              : (_ctx.pendingList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingList, (req) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: req.id,
                        class: _normalizeClass(["approval-card", _ctx.pushFocusClass(req.id)]),
                        "data-push-id": req.id
                      }, [
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "card-accent" }, null, -1)),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.getInitials(req.user ? req.user.name : 'E')), 1),
                            _createElementVNode("div", null, [
                              _createElementVNode("h3", _hoisted_9, _toDisplayString(req.user ? req.user.name : 'Unknown Employee'), 1),
                              _createElementVNode("span", _hoisted_10, "Manual " + _toDisplayString(req.type === 'in' ? 'Check-In' : 'Check-Out') + " Request", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "date-label" }, "REQUESTED DATE", -1)),
                              _createElementVNode("span", _hoisted_14, _toDisplayString(req.requested_date), 1)
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_ion_icon, { icon: _ctx.arrowForwardOutline }, null, 8, ["icon"])
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "date-label" }, "TIME", -1)),
                              _createElementVNode("span", _hoisted_17, _toDisplayString(req.time), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_ion_icon, { icon: _ctx.locationOutline }, null, 8, ["icon"]),
                            _createElementVNode("span", null, _toDisplayString(req.is_field_visit ? 'Field Visit' : (req.office ? req.office.name : 'Office')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "box-title" }, "Reason:", -1)),
                            _createElementVNode("p", _hoisted_20, "\"" + _toDisplayString(req.reason || 'No reason provided') + "\"", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("button", {
                            class: "btn-action btn-decline",
                            onClick: ($event: any) => (_ctx.promptDecline(req.id))
                          }, [
                            _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"]),
                            _cache[7] || (_cache[7] = _createElementVNode("span", null, "Decline", -1))
                          ], 8, _hoisted_22),
                          _createElementVNode("button", {
                            class: "btn-action btn-approve",
                            onClick: ($event: any) => (_ctx.approve(req.id))
                          }, [
                            _createVNode(_component_ion_icon, { icon: _ctx.checkmarkOutline }, null, 8, ["icon"]),
                            _cache[8] || (_cache[8] = _createElementVNode("span", null, "Approve Request", -1))
                          ], 8, _hoisted_23)
                        ])
                      ], 10, _hoisted_5))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.checkmarkDoneCircleOutline,
                        class: "empty-icon"
                      }, null, 8, ["icon"])
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("h3", null, "All Caught Up!", -1)),
                    _cache[11] || (_cache[11] = _createElementVNode("p", null, "You have no pending manual attendance requests to review.", -1))
                  ]))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}